import React, { useState, useContext, useEffect, useRef } from 'react'
import { backendStatus } from '../../../../../../backend/backend'
import Loading from '../../../../../../components/loading/loading'
import NetworksIcon from '../../../../../../components/icons/networks-icon'
import { DeviceContext } from '../../manage-page'
import Form from '../../../../../../components/form/form'
import Input from '../../../../../../components/input/input'
import Checkbox from '../../../../../../components/checkbox/checkbox'
import InfoPopup from '../../../../../../components/info-popup/info-popup'
import common from '../../../../../../components/form/validators/common'
import Select from '../../../../../../components/select/select'
import { RadioBandwidth, channelExtension, RadioFrequency, WirelessCipher, WirelessCrypto,DFS } from './wifi-constants'
import DefaultStatusModals from '../../../../../../components/modal/default-status-modals'
import InfoLine from '../../../../../../components/info-line/info-line'
import DeviceFactory from '../../../../../apis/device-factory'
import Button from '../../../../../../components/button/button'
import { useHistory } from 'react-router-dom'
import { isMinimalVersion } from '../bifrost-manage-page'
import Parameterize from '../../../../../../components/utils/parameterize'

const RETRY_TIME = 5000
const MIN_SSID_LENGTH = 1
const MAX_SSID_LENGTH = 32
const MIN_KEY_LENGTH = 8
const MAX_KEY_LENGTH = 63
const MODELS_WITH_160MHZ = ['TW-3000', 'W6-3000', 'W6-1500 G2']

const ModalStatus = {
    SAVING: 0,
    SUCCESS: 1,
    ERROR: 2,
    NOTHING: 3
}

export default function MonitoringWifiInfo() {

    const [wifi, setWiFi] = useState(null)
    const [radios, setRadio] = useState(null)
    const [status, setStatus] = useState(ModalStatus.NOTHING)

    const device = useContext(DeviceContext)
    const history = useHistory()

    const wirelessTimer = useRef(null)
    const radioTimer = useRef(null)
    const mounted = useRef(true)
    const versionCripto = [1, 30, 0]// minimum version encrypt and decrypt passwords

    const fetchWireless = async() => {

        let result = await device.retrieveResource('wireless')

        if(!result || result.status !== backendStatus.SUCCESS){
            console.log('Error fetching wireless:', result.content)
            if(mounted.current)
                wirelessTimer.current = setTimeout(fetchWireless, RETRY_TIME)
            return
        }
        if (isMinimalVersion(device.data, versionCripto)) {
            for (let i = 0; i < result.content.length; i++) {
                
                result.content[i].key = Parameterize(result.content[i].key, true)
            }
        }

        setWiFi(result.content)
    }

    const fetchRadio = async() => {

        let result = await device.retrieveResource('radio')

        if(!result || result.status !== backendStatus.SUCCESS){
            console.log('Error fetching radio:', result.content)
            if(mounted.current)
                radioTimer.current = setTimeout(fetchRadio, RETRY_TIME)
            return
        }

        setRadio(result.content)
    }

    useEffect(() => {

        fetchWireless()
        fetchRadio()

        return () => {
            mounted.current = false
            clearTimeout(wirelessTimer.current)
            clearTimeout(radioTimer.current)
        }

        // eslint-disable-next-line
    },[])

    const frequencies = [
        '2.4',
        '5'
    ]

    const securityOptions = [
        {value: WirelessCipher.WPA2, text: 'WPA2 (recomendado)'},
        {value: WirelessCipher.WPA_WPA2, text: 'WPA/WPA2'},
        {value: WirelessCipher.WPA2_WPA3, text: 'WPA2/WPA3'},
    ]

    const getRadio = (radioID) => {
        for(let r of radios) {
            if(r.id === radioID)
                return r
        }

        console.error("Radio not found, check your API responses")

        return null
    }

    const getRadioIndex = (radioID) => {

        for(let i in radios) {
            if(radios[i].id === radioID)
                return i
        }

        console.error("Radio not found, check your API responses")

        return null
    }

    const getFrequencyString = (wifi) => {

        let r = getRadio(wifi.radioID)

        return frequencies[r.frequency]
    }

    const getChannelOptions = (net) => {

        let radio = getRadio(net.radioID)

        let channels = []

        if(radio.frequency === RadioFrequency._2_4GHz){
            channels = [...Array(14).keys()]
        }else{
            channels = [0, 36, 40, 44, 48, 149, 153, 157, 161]
            if(radio.bandwidth === RadioBandwidth._20MHz)
                channels.push(165)
        }

        let opt = channels.map((c) => {return {value: c, text: c === 0 ? 'Automático' : String(c)}})
        if (radio.dfs && radio.dfs === DFS.ENABLED) {
            const dfsChannels = [
                { value: 52, text: '52 (DFS)' },
                { value: 56, text: '56 (DFS)' },
                { value: 60, text: '60 (DFS)' },
                { value: 64, text: '64 (DFS)' },
                { value: 100, text: '100 (DFS)' },
                { value: 104, text: '104 (DFS)' },
                { value: 108, text: '108 (DFS)' },
                { value: 112, text: '112 (DFS)' },
                { value: 116, text: '116 (DFS)' },
                { value: 120, text: '120 (DFS)' },
                { value: 124, text: '124 (DFS)' },
                { value: 128, text: '128 (DFS)' },
                { value: 132, text: '132 (DFS)' },
                { value: 136, text: '136 (DFS)' },
                { value: 140, text: '140 (DFS)' },
                { value: 144, text: '144 (DFS)' },
            ];
            opt.push(...dfsChannels);
            opt.sort((a, b) => a.value - b.value);
            opt = opt.filter(item => !item.text.includes('Automático'))
        } else {
            opt = opt.filter(item => !item.text.includes('DFS'))
        }

        if (radio.bandwidth === RadioBandwidth._160MHz) {
            opt = opt.filter(item => item.value <= 128)
        }


        return opt

    }

    const getChannelExtension = (wifiIndex) => {

        let net = wifi[wifiIndex]
        let radio = getRadio(net.radioID)

        if(radio.configuredChannel === 0 || radio.frequency === RadioFrequency._5GHz || radio.bandwidth === RadioBandwidth._20MHz)
            return null
   
        let available = channelExtension(radio.configuredChannel)
        //Conditional to fix taskheimdal#967 - when don't have a onchange event at extension select
        if (available.length === 1) radio.extension = available[0].value
        
        return<React.Fragment>
            {available.length === 1 ?
                <Input
                    label='Canal de extensão'
                    id='wifi-extension'
                    value={available[0].text}
                    disabled={true}
                ></Input> :
                <Select id='wifi-extension'
                    label='Canal de extensão'
                    value={radio.extension}
                    onChange={(e) => {
                        let i = getRadioIndex(radio.id)
                        radios[i].extension = Number(e.target.value)
                        setRadio([...radios])
                    }}
                    options={available}
                ></Select>
            }
        </React.Fragment>
    }

    const getChannel = (wifi) => {
        let i = getRadioIndex(wifi.radioID)
        return radios[i].channel
    }

    const getConfiguredChannel = (wifi) => {
        let i = getRadioIndex(wifi.radioID)
        return radios[i].configuredChannel
    }

    const getBandwidth = (wifi) => {
        let i = getRadioIndex(wifi.radioID)
        return radios[i].bandwidth
    }

    const has160Mhz = () => {

        if (MODELS_WITH_160MHZ.includes(device.data.model))
            
            return true

        return false
    }

    const getBandwidthOptions = (wifi) => {
        let i = getRadioIndex(wifi.radioID)
        let freq = radios[i].frequency
        let options = [
            {value: RadioBandwidth._20MHz, text: '20MHz'},
            {value: RadioBandwidth._40MHz, text: '20/40MHz'},
        ]

        if(freq === RadioFrequency._5GHz){
            options.push({value: RadioBandwidth._80MHz, text: '20/40/80MHz'})
            if (has160Mhz()){
                options.push({value: RadioBandwidth._160MHz, text: '20/40/80/160MHz'});
            }
        }

        return options
    }

    const getPasswordValidators = () => {

        let validators = [
            common.nonASCII,
            common.suspiciousString,
            common.anatelPasswordCriteria,]

        let minLength = 0

        if(!DeviceFactory.isTR069(device.data.model)) {
            validators.push(common.required)
            minLength = MIN_KEY_LENGTH
        }

        validators.push({fn: common.size, params:{min: minLength, max: MAX_KEY_LENGTH}})

        return validators
    }
    const is160MhzSelected = () => {

        if (radios[1]?.bandwidth === RadioBandwidth._160MHz)
            return true

        return false

    }

    const isDfsChannel = (index) => {
        if(radios[index]?.configuredChannel >= 52 && radios[index]?.configuredChannel <= 144)
            return true
        return false
    }

    const handleDfs = (index) => {

        if (radios[index].dfs === DFS.ENABLED && radios[index].configuredChannel === 0){
            radios[index].configuredChannel = 36
        } 
        if (radios[index].dfs === DFS.DISABLED && isDfsChannel(index)) {
            radios[index].configuredChannel = 0
        }
        radios[index].dfs = radios[index].dfs === DFS.ENABLED ? radios[index].dfs = DFS.DISABLED : radios[index].dfs = DFS.ENABLED

        setRadio([...radios]);
    };

    const handleBandWidth = (wifiIndex) => (e) => {
        let i = getRadioIndex(wifi[wifiIndex].radioID)
  
        radios[i].bandwidth = Number(e.target.value)
        if(is160MhzSelected() &&  radios[i].channel > 13 ){
            radios[i].dfs = DFS.ENABLED
            if ( radios[i].configuredChannel === 0){
                radios[i].configuredChannel = 36
            }
        }
        setRadio([...radios]);
    };

    const wifiForm = (wifiIndex) => {
        let net = wifi[wifiIndex]
        let radio = getRadio(net.radioID)
   
        return(
        <div key={`wifi-${wifiIndex}`} className='form-section'>


            <div className='dashboard-subtitle'>
                <NetworksIcon size='20'></NetworksIcon>
                <label>Rede {getFrequencyString(wifi[wifiIndex])} GHz</label>
            </div>

            <Input id={`wifi-ssid-${wifiIndex}`}
                name={`wifi-ssid-${wifiIndex}`}
                label='Nome da rede (SSID)'
                value={wifi[wifiIndex].ssid}
                onChange={(e) => {
                    wifi[wifiIndex].ssid = e.target.value
                    setWiFi([...wifi])
                }}
                validators={[
                    common.required,
                    common.nonASCII,
                    {fn: common.size, params:{min: MIN_SSID_LENGTH, max: MAX_SSID_LENGTH}},
                ]}
            >
            </Input>

            <Select id={`wifi-security-${wifiIndex}`}
                name={`wifi-security-${wifiIndex}`}
                label='Segurança'
                value={wifi[wifiIndex].cipher}
                options={securityOptions}
                onChange={(e) => {
                    wifi[wifiIndex].cipher = Number(e.target.value)
                    wifi[wifiIndex].crypto = wifi[wifiIndex].cipher === WirelessCipher.NONE ? WirelessCrypto.NONE : WirelessCrypto.AES
                    setWiFi([...wifi])
                }}
            ></Select>

            <Input id={`wifi-password-${wifiIndex}`}
                name={`wifi-password-${wifiIndex}`}
                label='Senha da rede'
                type='password'
                value={wifi[wifiIndex].key}
                onChange={(e) => {
                    wifi[wifiIndex].key = e.target.value
                    setWiFi([...wifi])
                }}
                collapse={wifi[wifiIndex].cipher === WirelessCipher.NONE}
                validators={getPasswordValidators()}
                passwordMeter={true}
            >
            </Input>
            {radio.dfs !== DFS.NOT_SUPPORTED && radio.dfs !== undefined ?
            <div className='with-info' id='radio-dfs'>
                    <Checkbox
                        id={`${radio.id}-dfs`}
                        label='Habilitar canais com DFS'
                        value={radio.dfs}
                        toggleFn={() => handleDfs(wifiIndex)}
                        disabled={is160MhzSelected()}
                    ></Checkbox>
                    <InfoPopup
                        message={<div style={{width: '250px'}}>
                            Ao habilitar canais DFS você terá uma maior faixa de canais para utilização, contudo: <br></br>
                            - A inicialização da rede Wi-Fi será mais lenta pois o roteador necessita verificar se o canal DFS está livre para uso, podendo levar até 10 minutos.<br></br>
                            - Pode haver incompatibilidades com dispositivos que não tem suporte a esses canais.<br></br>
                            - Em operação, caso seja identificado um sinal de caráter primário (Ex: Radar), o roteador irá operar em um novo canal, podendo causar desconexão temporária dos dispositivos.
                        </div>}
                    ></InfoPopup>
                </div> : null}

            <Select id={`wifi-channel-${wifiIndex}`}
                name={`wifi-channel-${wifiIndex}`}
                label='Canal'
                value={getConfiguredChannel(wifi[wifiIndex])}
                options={getChannelOptions(wifi[wifiIndex])}
                onChange={(e) => {
                    let i = getRadioIndex(wifi[wifiIndex].radioID)
                    radios[i].configuredChannel = Number(e.target.value)
                    setRadio([...radios])
                }}
            ></Select>

            <InfoLine
                label='Canal atual'
                value={getChannel(wifi[wifiIndex])}
            ></InfoLine>

            {!DeviceFactory.isTR069(device.data.model) && <Select id={`wifi-bandwidth-${wifiIndex}`}
                name={`wifi-bandwidth-${wifiIndex}`}
                label='Largura de banda'
                value={getBandwidth(wifi[wifiIndex])}
                options={getBandwidthOptions(wifi[wifiIndex])}
                onChange={handleBandWidth(wifiIndex)}
            ></Select>}


            {getChannelExtension(wifiIndex)}

        </div>
        )


    }

    const saveWifi = async() => {
        let resultVersion = isMinimalVersion(device.data, versionCripto)
        setStatus(ModalStatus.SAVING)

        let radioIDs = []

        for(let net of wifi){

            if(!net.isRoot)
                continue

            radioIDs.push(net.radioID)
            if (resultVersion) {
                net.key = Parameterize(net.key)
            }

            let result = await device.updateResource('wireless', net)
            if (resultVersion) {
                net.key = Parameterize(net.key, true)
            }

            if (!result || result.status !== backendStatus.SUCCESS){
                console.error(result.content)
                setStatus(ModalStatus.ERROR)
                return
            }
        }

        for(let radio of radios){

            if(!radioIDs.includes(radio.id))
                continue

            let result = await device.updateResource('radio', radio)
            if(!result || result.status !== backendStatus.SUCCESS){
                console.error(result.content)
                setStatus(ModalStatus.ERROR)
                return
            }
        }

        if (isMinimalVersion(device.data, [1,21,7])){
            let result = await device.updateResource('band_steering',
                 { enabled: wifi[0].ssid === wifi[1].ssid }
                )
            if (!result || result.status !== backendStatus.SUCCESS) {
                console.error(result.content)
                setStatus(ModalStatus.ERROR)
                return
            }
        }
        let result = await device.apply()
        if(!result || result.status !== backendStatus.SUCCESS){
            console.error(result.content)
            setStatus(ModalStatus.ERROR)
            return
        }

        setStatus(ModalStatus.SUCCESS)
    }

    return <div id='wifi-management-page'>

        <Button id='site-survey-button'
            text='Site survey'
            onClick={() => history.push(`/manage/${device.data.deviceid}/wifi/site-survey`)}
        ></Button>

        <DefaultStatusModals
            saving={status === ModalStatus.SAVING}
            success={status === ModalStatus.SUCCESS}
            error={status === ModalStatus.ERROR}
            continueFn={() => setStatus(ModalStatus.NOTHING)}
        ></DefaultStatusModals>

        {!wifi || !radios ? <Loading show={true}></Loading> :
        <Form id='wifi-management-info'
            submitText='Aplicar'
            onSubmit={saveWifi}
        >


            {wifi.map((net, i) => {
                if(!net.isRoot) return null
                return wifiForm(i)
            })}

        </Form>}

    </div>
}
